/*
 * � 2020 Microsoft. All rights reserved.
 */

define(
	'SolitaireShared/CardLogic/ChallengeConstants',{
		KeyScoreRequired: "SCOREREQUIRED",
		KeyBoardsToClear: "BOARDSTOCLEAR",
		KeyStacksRequired: "STACKSREQUIRED"
	}
);
